import request from '@/utils/request'

// v80InspRes
export function v80InspRes(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020/v80InspRes`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getInspKind
export function getInspKind(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020/getInspKind`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80o1020List
export function v80o1020List(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020/v80o1020List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80o1020Update
export function v80o1020Update(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020/v80o1020Update`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80o1020Delete
export function v80o1020Delete(param) {
  let data = param
  return request({
    url: `/inspection/v80o1020/v80o1020Delete`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}